import React from 'react';
import ReactClass from 'create-react-class';
import Parse from 'parse';
import {Link} from 'react-router-dom'
import {Button, Glyphicon} from 'react-bootstrap';
import OpenActions from './open-actions';
import ModalProject from './ModalProject';

// const COMPLETED = "completed";
// const ROLE_TM = "TM";
// const ROLE_APL = "APL";
// const ROLE_PL = "PL";

export default ReactClass({

    getInitialState() {
        return {
            projects: [],
        }
    },

    componentDidMount() {
        this.fetchProjectList();
    },

    handleChange(event) {
        this.setState({[event.target.name]: event.target.value});
    },

    fetchProjectList() {

        let _this = this;
        let Project = Parse.Object.extend("Project");
        let query = new Parse.Query(Project);
        query.notEqualTo("deleted", true);
        query.ascending("name");
        
        this.projectRequest =
            query.find().then(async (results) => {

                let projects = [];

                for (let project of results) {

                    if (project) {
                        projects.push({
                            id: project.id,
                            name: project.get("name"),
                            code: project.get("code"),
                            codeLowercase: project.get("codeLowercase"),
                            mail: project.get("code") + "@atappmail.com",
                            link: "project/" + project.id,
                        });

                    }
                }


                _this.setState({
                    projects: projects,
                });

            }).catch(function (e) {
                console.log(e);
            });
    },

    newProject() {
        this.setState({showModal: true});
    },
    removeProject(e, projectId) {

        let _this = this;
        if (window.confirm("Are you sure you want to archive this project?")) {
            let projectQuery = new Parse.Query("Project");
            projectQuery.get(projectId).then(action => {
                action.set("deleted", true);
                action.save().then(() => {
                    let projects = _this.state.projects;
                    for (let i = 0; i < projects.length; i++) {
                        let project = projects[i];
                        if (project.id === projectId) {
                            projects.splice(i, 1);
                            break;
                        }
                    }
                    _this.setState({
                        actionsJSON: projects,
                    });
                })
            }).catch((e) => {
                console.warn(e);
            })
        }

    },
    closeModal(project) {
        if(project !== undefined && project.id !== undefined) {
            let projects = this.state.projects || [];
            projects.push({
                id: project.id,
                code: project.get("code"),
                codeLowercase: project.get("codeLowercase"),
                name: project.get("name"),
                mail: project.get("code") + "@atappmail.com",
                link: "project/" + project.id,
            });
            this.setState({projects: projects, showModal: false});
        } else {
            this.setState({showModal: false});
        }
    },
    render() {
        return (
            <div className="negative-margin">
                <h2>
                    Projects
                    <Button bsStyle="primary" bsSize="small" className="pull-right" onClick={this.newProject}>
                        <Glyphicon glyph="plus"/>&nbsp;
                        New project
                    </Button>
                </h2>
                {
                    this.state.projects.length > 0 ? (
                        <table className="table table-striped">
                            <thead>
                            <tr>
                                <th>Name</th>
                                <th>Code</th>
                                <th>E-mail</th>
                                <th>Open actions</th>
                                <th></th>
                            </tr>
                            </thead>
                            <tbody>
                            {this.state.projects.map((project) => {
                                return (
                                    <tr key={"prj" + project.id} className="project">
                                        <td><Link to={project.link}>{project.name}</Link></td>
                                        <td>{project.code} ({project.codeLowercase})</td>
                                        <td><a href={"mailto:" + project.mail}>{project.mail}</a></td>
                                        <td><OpenActions project={project} /></td>
                                        <td className="hidden-xs">
                                            <Button bsSize="small" bsStyle="danger"
                                                    onClick={(e) => this.removeProject(e, project.id)}>
                                                <Glyphicon glyph="trash"/>
                                            </Button>
                                        </td>
                                    </tr>
                                );
                            })}
                            </tbody>
                        </table>
                    ) : (
                        <em>No projects added yet.<br /><br /></em>
                    )
                }

                <ModalProject show={this.state.showModal} close={this.closeModal} />
            </div>
        );
    },

});


// WEBPACK FOOTER //
// ./src/projects-admin.js